/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FragranceInputs */

const en_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragrance`)
};

const es_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragancia`)
};

const fr_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parfum`)
};

const de_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düfte`)
};

const ja_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレグランス`)
};

const zh_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`香水/香氛`)
};

const ar_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عطور`)
};

const id_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewangian`)
};

const it_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profumi`)
};

const ru_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Парфюмерия`)
};

const pt_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragrância / Perfume`)
};

const ko_val_fragrance = /** @type {(inputs: Val_FragranceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`향수`)
};

/**
* | output |
* | --- |
* | "Fragrance" |
*
* @param {Val_FragranceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_fragrance = /** @type {((inputs?: Val_FragranceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FragranceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_fragrance(inputs)
	if (locale === "es") return es_val_fragrance(inputs)
	if (locale === "fr") return fr_val_fragrance(inputs)
	if (locale === "de") return de_val_fragrance(inputs)
	if (locale === "ja") return ja_val_fragrance(inputs)
	if (locale === "zh") return zh_val_fragrance(inputs)
	if (locale === "ar") return ar_val_fragrance(inputs)
	if (locale === "id") return id_val_fragrance(inputs)
	if (locale === "it") return it_val_fragrance(inputs)
	if (locale === "ru") return ru_val_fragrance(inputs)
	if (locale === "pt") return pt_val_fragrance(inputs)
	return ko_val_fragrance(inputs)
});